export default __webpack_public_path__ + "static/media/asdfg.c5aa3ec5.mp4";